import { Injectable } from '@angular/core';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { SendRegistrationKeyCommandHandler } from './send-registration-key-command-handler.service';
import { standardCommand } from '../../../core/model/command';
import { CleanupTenantCommandHandler } from './cleanup-tenant-command-handler.service';
import { PrintGdprCommandHandler } from './print-gdpr-command-handler.service';
import { TenantCommandHandlerResolverBase } from './tenant-command-handler-resolver.base';
import { ShowInvoicesCommandHandler } from './show-invoices-command-handler.service';
import { EditCommandHandler } from '../../../core/service/command/edit-command-handler.service';
import { RepayBalanceCommandHandler } from './repay-balance-command-handler.service';
import { ShowFaultNotificationCommandHandler } from './show-fault-notification-command-handler.service';
import { ContactExportCommandHandler } from './contact-export-command-handler.service';
import { MoveBalanceCommandHandler } from './move-balance-command-handler.service';
import { tenantCommand } from '../../model/const/command';

@Injectable()
export class TenantCommandHandlerResolver extends TenantCommandHandlerResolverBase {
  constructor(
    cleanupHandler: CleanupTenantCommandHandler,
    deleteHandler: DeleteCommandHandler,
    editHandler: EditCommandHandler,
    gdprHandler: PrintGdprCommandHandler,
    sendKeyHandler: SendRegistrationKeyCommandHandler,
    showInvoiceHandler: ShowInvoicesCommandHandler,
    repayBalanceHandler: RepayBalanceCommandHandler,
    moveBalanceHandler: MoveBalanceCommandHandler,
    showFaultNotificationHandler: ShowFaultNotificationCommandHandler,
    exportHandler: ContactExportCommandHandler
  ) {
    super(
      cleanupHandler,
      gdprHandler,
      sendKeyHandler,
      showInvoiceHandler,
      repayBalanceHandler,
      showFaultNotificationHandler,
      exportHandler
    );
    this.addHandler(standardCommand.delete, deleteHandler);
    this.addHandler(standardCommand.edit, editHandler);
    this.addHandler(tenantCommand.moveBalance, moveBalanceHandler);
  }
}
